import ApiServer from "../ApiServer.ts";
import * as modal from "../util/modal.ts";
import * as FwDatas from "../FwDatas.ts";
import * as libLocation from "../lib/location.ts";
import * as Html from "../util/Html.ts";

Html.registerWidget('widget/view-invitation-opener',{initDom})

var currentModal : modal.DomModal;
ApiServer["custom.famupdateinvitationresend"] = ApiServer.group([
  ApiServer.famupdateinvitation,
  ApiServer.famresendinvite
],function(){
  modal.closeDomModal(currentModal);
  libLocation.refresh();
});

Html.registerDom({
  modalinvitation(){
    var metaId = this.getAttribute("data-fw-meta-id");
    FwDatas.getFamily().invitations.forEach(function(invitation){
      if(invitation.metaId===metaId){
        if(invitation.editable){
          import("../modal/invitation_edit.mustache").then(TPL=>{
            currentModal = modal.openDomModal(TPL,invitation);
          })
        }else{
          import("../modal/invitation_view.mustache").then(TPL=>{
            currentModal = modal.openDomModal(TPL,invitation);
          })
        }
      }
    });
  },
  async invitationdelete(){
    var metaId = Html.getDomMetaId(this);
    if(!await modal.confirmDelete('editAccount.confirmBeforeDeletingFamilyMember')) return;

    await ApiServer.famcancelinvite(metaId)
    modal.closeDomModal(currentModal);
    
    await libLocation.refresh();
    modal.alert("editAccount.familyMemberDeleted");


  }
});

function initDom(obj: HTMLElement){
  obj.setAttribute('data-fw-onclick', "modalinvitation");
}

export {initDom}